export default function getForwardedClientHeaders(req) {
  const clientIp = req?.headers?.['x-real-ip'];
  const clientPort = req?.headers?.['x-client-port'];

  return {
    ...(clientIp && {
      'X-Real-IP': clientIp,
      'X-Forwarded-For': clientIp,
    }),
    ...(clientPort && { 'X-Client-Port': clientPort }),
  };
}
